import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import AppLandingPage from "../../All_Projects_Landing_Pages/AppLandingPage";

import Report from "../../common/Report";
import { FieldsProvider } from "../../../context/FieldsContext";
import PrediabetesPatientReport from "../../pdfReports/PrediabetesPdfReport";
import {
  getImagesFromDB,
  fetchAndStoreImages,
} from "../../../utils/imageUtils";
import PrebiabetesDetailsPage from "../../All_Project_Components/PrediabetesComponent";

const PrediabetesRoutes = (props) => {
  const PREDIABETES_LANDING_URL =
    "https://clinical-server-apis.azurewebsites.net/fields/prediabetes";
  const PREDIABETES_REPORT_URL =
    "https://clinical-server-apis.azurewebsites.net/prediabetes";

  const app = "prediabetes";

  const [formDetails, setFormDetails] = useState({});
  const [PdfInfo, setPDFDetails] = useState({});
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [units, setUnits] = useState({});

  const color = "#f77f00";
  const secondaryColor = "#ff901a";
  const button_hover_color = "#ff9c33";

  const surface_color = "rgb(254 247 239)";
  const surface_hover_color = "#e8e0e8";
  const surface_highlight_color = "#dcdaf5";

  const form_details = (props) => {
    const details = {
      patient_id: props.patient_id,
      name: props.name,
      age: props.age,
      gender: props.gender,
      location: props.location,
      email: props.email,
      phone: props.phone,
      alcohol: props.alcohol,
      alcohol_sub: props.alcohol_sub,
      bmi: parseFloat(props.BMI),
      change_in_weight: props.change_in_weight,
      diet: props.diet,
      dyslipidaemia: props.dyslipidemia,
      dyslipidemia_list: props.dyslipidemia_list,
      history: props.familyHistory,
      family_history_list: props.family_history_list,
      height: parseInt(props.height),
      hypertension: props.hypertension,
      hypertension_list: props.hypertension_list,
      hypertension_second_list: props.hypertension_second_list,
      hypertension_third_list: props.hypertension_third_list,
      medical_history: props.medical_history,
      medical_history_list: props.medical_history_list,
      medical_second_history_list: props.medical_second_history_list,
      physical_activity: props.physical_activity,
      symptoms: props.symptoms,
      symptoms_list: props.symptoms_list,
      waist: props.waist,
      weight: parseInt(props.weight),
    };

    const pdf_details = {
      basic_info: {
        UHID: props.patient_id,
        Name: props.name,
        Age: props.age,
        Gender: props.gender,
        Location: props.location,
        Mobile: props.phone,
      },
      "Vital Signs": {
        Height: props.height,
        Weight: parseInt(props.weight),
        BMI: parseFloat(props.BMI),
      },

      "Life Style": {
        Alcohol: props.alcohol,
        Diet: props.diet,
        "Physical Activity": props.physical_activity,
        "Change in Weight": props.change_in_weight,
        "Waist Circumference": props.waist,
      },

      "Medical History": {
        Dyslipidaemia: props.dyslipidemia,
        "Family History": props.familyHistory,
        Hypertension: props.hypertension,
        "Medical History": props.medical_history,
        Symptoms: props.symptoms,
      },
    };

    const units = {
      Height: "cm",
      Weight: "kg",
      BMI: "kg/m2",
      "Waist Circumference": "inches",
      "Change in Weight": "kg",
    };
    setUnits(units);

    setFormDetails(details);
    setPDFDetails(pdf_details);
  };

  useEffect(() => {
    const loadImages = async () => {
      try {
        const storedImages = await getImagesFromDB(app);
        if (storedImages.length > 0) {
          setImages(storedImages);
        } else {
          const urls = [
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo-logo.png",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/iStock-1296077052-min.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/prediabetes-app-page-1.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/prediabetes-app-page-2.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/intepretation-img-3.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo_certificate_MD%20763515.png",
          ];
          await fetchAndStoreImages(app, urls, setImages);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false); // End loading
      }
    };
    loadImages();
  }, []);

  return (
    <FieldsProvider>
      <Routes>
        <Route
          path="/"
          element={
            <AppLandingPage
              LANDING_URL={PREDIABETES_LANDING_URL}
              app={app}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              secondaryColor={secondaryColor}
              images={images}
              loading={loading}
              button_hover_color={button_hover_color}
            />
          }
        />
        <Route
          path="patient-details"
          element={
            <PrebiabetesDetailsPage
              app={app}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
              form_details={form_details}
            />
          }
        />
        <Route
          path="report"
          element={
            <Report
              app={app}
              formDetails={formDetails}
              REPORT_URL={PREDIABETES_REPORT_URL}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
            />
          }
        />
        <Route
          path="pdfreport"
          element={
            <PrediabetesPatientReport
              app={app}
              formDetails={formDetails}
              PdfInfo={PdfInfo}
              units={units}
            />
          }
        />
      </Routes>
    </FieldsProvider>
  );
};

export default PrediabetesRoutes;
